export const LEDGER_GROUPS_LIST = "ledger_groups_list"; 
export const LEDGER_GROUPS_LIST_SUCCESSFULL = "ledger_groups_list_successfull";
export const CREATE_LEDGER_GROUPS_MASTER = "create_ledger_groups_master"; 
export const CREATE_LEDGER_GROUPS_MASTER_SUCCESSFULL = "create_ledger_groups_master_successfull";
export const UPDATE_LEDGER_GROUPS_MASTER = "update_ledger_groups_master"; 
export const UPDATE_LEDGER_GROUPS_MASTER_SUCCESSFULL = "update_ledger_groups_master_successfull";